import React, { useState } from 'react';
import { Check, X, ArrowRight, Clock, Target, Shield, BarChart3, Users, Layers, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
import { CampaignSelector } from '../components/CampaignSelector';
const fmt = (n: number) => n.toLocaleString('en-US');
export function AdvantageProduct() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = isPartial ? 6500 : 6500 + 1000 * (campaignMode - 1);
  const systemFee = 2500;
  const campaignFee = isPartial ? 1250 : 2500 * campaigns;
  const monthlyTotal = systemFee + campaignFee;
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-460" data-mp="2aqnf0b1sllq">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-461" data-mp="1hqpe0xomfyy8">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-462" data-mp="1dpnesgupfmw9" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-463" data-mp="2xovy2i6xlaq4">
          <div className="inline-block px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-6" data-id="element-464" data-mp="3bl9gbtjahg5n">
            Flagship Partnership
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-465" data-mp="2iy6k58235hik">
            HIRE Advantage
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto leading-relaxed" data-id="element-466" data-mp="2nuwy9puby31c">
            HIRE Advantage is the partnership where recruiting becomes
            consistent, predictable, and scalable.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-467" data-mp="2052rnq0ltapj">
        <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="mint" data-id="element-468" data-mp="33gi5t4nl4p26" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-469" data-mp="2yh5kiocd3q1p">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-470" data-mp="3cchcinz4v2ex">
            <div className="mb-4" data-id="element-471" data-mp="38b5mihcckf67">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-472" data-mp="2kifbcac9pzwz">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-473" data-mp="2fmgst3dmfc4h">
                ${fmt(buildFee)}
              </div>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-474" data-mp="2oksgoxn3rvt8">
                {['Company and opportunity profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and ad copywriting', 'Landing pages and candidate application flows', 'Full funnel design, from ad to onboarding', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Team training and 90-day coaching to optimize output'].map((point, i) => <li key={i} className="flex items-start" data-id="element-475" data-mp="7d0t0ted2prf" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-476" data-mp="v1juaoyzu2a0" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-477" data-mp="100wm7o4q1zjg">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-[#7FE0C3]/30 p-6 rounded-xl relative" data-id="element-478" data-mp="q9ikrat7mpno">
            <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3] rounded-t-xl" data-id="element-479" data-mp="1dzmm1bixedbi" />
            <div className="mb-4" data-id="element-480" data-mp="1it8q4fb0x8vp">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-481" data-mp="1ith09zfri037">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-482" data-mp="3m9dwmyv3yt5n">
                ${fmt(monthlyTotal)}
              </div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-483" data-mp="3hb2oqtodisq2">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-484" data-mp="3cc9b919371pw">
                <div className="flex justify-between text-sm" data-id="element-485" data-mp="dtkj8sw2pxst">
                  <span className="text-slate-400" data-id="element-486" data-mp="dt123ee8zdfu">System Fee</span>
                  <span className="text-white font-medium" data-id="element-487" data-mp="8vsg12pzap9b">
                    ${fmt(systemFee)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-488" data-mp="41o5yalf2140">
                  <span className="text-slate-400" data-id="element-489" data-mp="3v9iv2jibqh7o">
                    {isPartial ? 'Partial Campaign' : campaigns === 1 ? 'Campaign Management' : `Campaign Management (x${campaigns})`}
                  </span>
                  <span className="text-white font-medium" data-id="element-490" data-mp="z6ay530fl8ow">
                    ${fmt(campaignFee)}
                  </span>
                </div>
              </div>

              <ul className="mt-5 space-y-2 pt-4 border-t border-slate-800/50" data-id="element-491" data-mp="192e98yd9ghnz">
                {['Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-492" data-mp="1ruqafhs6hcwj" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-493" data-mp="1ws8mvi5ema9a" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-494" data-mp="21rlbo8fu5rei">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-495" data-mp="6nn8emnwfj9k">
            <div className="mb-4" data-id="element-496" data-mp="1plra7a19u0q">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-4" data-id="element-497" data-mp="1qn168fbcagv">
                Sales School Tickets
              </div>
              <div className="flex items-baseline mb-2" data-id="element-498" data-mp="fil6s99tfo8a">
                <span className="text-3xl font-bold text-white" data-id="element-499" data-mp="ap8hry185ff0">$150</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-500" data-mp="pe4yskl9e2rr">per ticket</span>
              </div>
              <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-501" data-mp="kgmmqlby37fj">
                Sales School tickets are purchased separately based on the number
                of attendees, up to a $5,000 monthly maximum.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg max-w-3xl mx-auto" data-id="element-502" data-mp="3080p0fuyy4mb">
          <p className="text-[#7FE0C3] text-center font-medium" data-id="element-503" data-mp="2w6p9521wcxrb">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 2. PROBLEM REFRAME */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-504" data-mp="2q4vis2xm8phj">
        <div className="text-center mb-12" data-id="element-505" data-mp="2c9taxa97kq23">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-506" data-mp="2h9p6cl3ub961">
            The Real Problem
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-507" data-mp="22cf0br9yuvhp">
            Most companies don't fail at finding candidates. They fail at system
            execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-508" data-mp="1tdjq843sx194">
          <div className="bg-slate-900/30 border border-slate-800 p-8 rounded-xl" data-id="element-509" data-mp="1tf4lxx1uqq8k">
            <h3 className="text-sm text-rose-400 uppercase tracking-widest font-bold mb-6" data-id="element-510" data-mp="1ydz2stg9e4q1">
              System Failures
            </h3>
            <ul className="space-y-4" data-id="element-511" data-mp="3sqfi0jr18t71">
              {['Inconsistent interviews', 'Drifting hiring standards', 'Early churn discovered too late', 'Leaders relying on gut decisions'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-512" data-mp="vevu37eckcb2" data-mpi={idx}>
                  <X className="w-5 h-5 text-rose-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-513" data-mp="vd16flboy63a" />
                  <span className="line-through opacity-70" data-id="element-514" data-mp="rdaaz4b7z1sf">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex flex-col justify-center p-8" data-id="element-515" data-mp="hfmby26kz84g">
            <p className="text-xl text-white font-medium mb-4" data-id="element-516" data-mp="he1m2pv7odcx">
              Advantage solves the system failure, not just the talent shortage.
            </p>
            <p className="text-slate-400" data-id="element-517" data-mp="8fpvuoy9bhl0">
              We replace guesswork with infrastructure and accountability.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT ADVANTAGE IS */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-518" data-mp="22u0jiu3485p7">
        <div className="max-w-5xl mx-auto" data-id="element-519" data-mp="3kp9eeh3nx1ca">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-520" data-mp="3kohqztk7y9x3">
            <div data-id="element-521" data-mp="3pnkngpm4v7tg">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-522" data-mp="3pn2i93hhtj9e">
                Full System Ownership
              </h2>
              <div className="space-y-4 text-slate-400 mb-8" data-id="element-523" data-mp="2c31yjent57g">
                <p data-id="element-524" data-mp="2efjivgi9djz">This is not lead generation.</p>
                <p data-id="element-525" data-mp="31s86ooiq4n4n">This is not outsourced recruiting.</p>
                <p data-id="element-526" data-mp="31tsza8lh9vzv">This is full ownership of the recruiting system.</p>
              </div>
              <div className="p-6 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-527" data-mp="36sngx77pleie">
                <p className="text-[#7FE0C3] font-medium" data-id="element-528" data-mp="3aqtlc8l2ri05">
                  HIRE Advantage is the only partnership level where HIRE is
                  accountable for the recruiting system actually working.
                </p>
              </div>
            </div>
            <div className="space-y-6" data-id="element-529" data-mp="uzyyno48ax48">
              <div className="flex items-start" data-id="element-530" data-mp="v33bf9vrf16i">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-531" data-mp="2ic8wrnmdhqm3">
                  <Shield className="w-6 h-6 text-[#7FE0C3]" data-id="element-532" data-mp="2n8h8ss59x3p1" />
                </div>
                <div data-id="element-533" data-mp="2s1shkytnbujl">
                  <h3 className="text-white font-bold mb-2" data-id="element-534" data-mp="2s3mrli3dq28w">Accountability</h3>
                  <p className="text-slate-400 text-sm" data-id="element-535" data-mp="2wzk93rqdpen9">
                    We don't just deliver leads; we own the outcome of the
                    system's performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-536" data-mp="29aspvpuro6mm">
                <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-537" data-mp="299zl2ufdbr74">
                  <Target className="w-6 h-6 text-[#7FE0C3]" data-id="element-538" data-mp="3kpy33nsixnkh" />
                </div>
                <div data-id="element-539" data-mp="3ksahxs2zjhtb">
                  <h3 className="text-white font-bold mb-2" data-id="element-540" data-mp="3or9kx755p4i4">Consistency</h3>
                  <p className="text-slate-400 text-sm" data-id="element-541" data-mp="3otdxsel19duj">
                    Eliminating the variance between good weeks and bad weeks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 10-STEP SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-542" data-mp="149rmlro94x6o">
        <div className="text-center mb-12" data-id="element-543" data-mp="zbzwn3763l54">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-544" data-mp="zayigpuuuij6">
            The 10-Step Recruiting System
          </h2>
          <p className="text-slate-400" data-id="element-545" data-mp="pevbn6p25vpw">
            Every HIRE Advantage partner runs the same system. The difference is
            who owns it.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-546" data-mp="leuuheakr6f5">
          {['Attract', 'Engage', 'Screen', 'Qualify', 'Commit', 'Schedule', 'Launch', 'Integrate', 'Train', 'Retain'].map((step, idx) => <div key={idx} className="bg-slate-900/40 border border-slate-800 p-6 rounded-lg text-center hover:border-[#7FE0C3]/30 transition-colors group" data-id="element-547" data-mp="2twb7huaty91i" data-mpi={idx}>
              <div className="text-xs text-slate-500 mb-2 font-mono" data-id="element-548" data-mp="2kwo7ncxr1bak">
                0{idx + 1}
              </div>
              <div className="text-white font-medium group-hover:text-[#7FE0C3] transition-colors" data-id="element-549" data-mp="2pvrcoxdqbhij">
                {step}
              </div>
            </div>)}
        </div>
      </section>

      {/* 5. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-550" data-mp="3hk1h7w52r2mj">
        <div className="max-w-6xl mx-auto" data-id="element-551" data-mp="33m4hiqvbqg3n">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-552" data-mp="38kxy4s5wqn81">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-553" data-mp="1s664yd0xtbxo">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-[#7FE0C3]/20 rounded-xl p-8 relative overflow-hidden" data-id="element-554" data-mp="1x73mcne4i1y4">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-555" data-mp="1pl86yyydjvsy" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-556" data-mp="1kmn6cyf7na3z">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-557" data-mp="1ynpt7de14ofy" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-558" data-mp="1tpoawuofgt5j">
                {['Recruiting system architecture (custom ATS)', 'Traffic, screening, and qualification standards', 'Hiring consistency and interview structure', 'Sales School and launch readiness', 'Early performance tracking and correction', 'Ongoing optimization and accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-559" data-mp="n7j0mys83yuk" data-mpi={idx}>
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-560" data-mp="i97uay1506h3" />
                    <span data-id="element-561" data-mp="vvyeq8hkd1yg">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-562" data-mp="10w2vlzmdvyp7">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-563" data-mp="15tcl1f9rwad1" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-564" data-mp="1al2vdl8pmy4g">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-565" data-mp="1emxxut2dnhjt" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-566" data-mp="1jkpxyad6e9z3">
                {['Final hiring decisions', 'Day-to-day sales leadership', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-567" data-mp="1thclj6wvzf4t" data-mpi={idx}>
                    <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-568" data-mp="3qdtjlpoykv3p">
                      <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-569" data-mp="2cgh017lfrfog" />
                    </div>
                    <span data-id="element-570" data-mp="27oz0mnz29n5l">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 6. TIMELINE */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-571" data-mp="1yosp37mxax92">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-572" data-mp="1ymg3mkhyi4r9">
          Partnership Timeline
        </h2>

        <div className="relative" data-id="element-573" data-mp="2rd83bry8dbjc">
          {/* Horizontal connector line (desktop only) */}
          <div className="hidden md:block absolute top-3 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-[#7FE0C3]/30 to-transparent" data-id="element-574" data-mp="2me4zubxwfddh" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-575" data-mp="2heik9vulll1i">
            {[{
            days: 'Days 1–21',
            title: 'Build & Launch',
            items: ['System architecture build', 'Campaign launch', 'Sales School setup', 'First candidates generated']
          }, {
            days: 'Weeks 4–12',
            title: 'Support & Consulting',
            items: ['Weekly support and consulting', 'Establishing strong baseline KPIs', 'Interviewing 30+ triple screened prospects/mo', 'Hiring 15+ people/mo']
          }, {
            days: 'Month 3+',
            title: 'Optimization',
            items: ['Increase conversion rates', 'Improve retention', 'Maximize ROI', 'Scale successful patterns']
          }].map((phase, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-576" data-mp="aqia6ehbremf" data-mpi={idx}>
                {/* Timeline dot */}
                <div className="hidden md:flex items-center justify-center w-6 h-6 rounded-full bg-[#0A0F1C] border-2 border-[#7FE0C3] z-10 mb-8" data-id="element-577" data-mp="3na4a64cfpu59">
                  <div className="w-2 h-2 rounded-full bg-[#7FE0C3]" data-id="element-578" data-mp="3icubrz72i85a" />
                </div>

                <div className="w-full bg-slate-900/30 border border-slate-800 p-6 rounded-xl text-center md:text-left" data-id="element-579" data-mp="14qtmrfwpzil">
                  <div className="text-[#7FE0C3] font-bold text-sm uppercase tracking-widest mb-2" data-id="element-580" data-mp="3sbjufu6sfwml">
                    {phase.days}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-581" data-mp="53pvg36cdg5t">
                    {phase.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-582" data-mp="jsvr5h5z0o8y">
                    {phase.items.map((item, i) => <li key={i} className="text-slate-400 text-sm flex items-start justify-center md:justify-start" data-id="element-583" data-mp="evcdojh3kfi2" data-mpi={i}>
                        <span className="w-1.5 h-1.5 rounded-full bg-slate-700 mr-2 mt-1.5 flex-shrink-0" data-id="element-584" data-mp="oubclac28wrv" />
                        <span data-id="element-585" data-mp="1v7g6wn331og1">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. WHO THIS IS FOR */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-586" data-mp="2977eo630a8ll">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-587" data-mp="295d33idmjsu6">
          <div data-id="element-588" data-mp="1cihweengvdz3">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-589" data-mp="1cj1ga0wogcfr">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-590" data-mp="1hh2y6iida5pn" />
              This is for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-591" data-mp="1lglj3ea6ugsh">
              {['Want recruiting to actually work', 'Value consistency over heroics', 'Are open to better systems', 'Want a partner, not a vendor'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-592" data-mp="xqr68wpvcs88" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-593" data-mp="q7qbazt4w6wh" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-594" data-mp="h7uy6pg0q1tt">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-595" data-mp="h7bnntsp6fpt">
              <X className="w-5 h-5 text-rose-500 mr-2" data-id="element-596" data-mp="c9jku4qil96u" />
              This is not for teams who:
            </h3>
            <ul className="space-y-4" data-id="element-597" data-mp="7a6wtgnwpw2o">
              {['Only want resumes', "Aren't open to process", 'Want zero accountability'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-598" data-mp="3tqb8vbuhtab8" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-rose-500 mr-3 mt-2" data-id="element-599" data-mp="3popnt37t1ppy" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 9. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-600" data-mp="3fqik3m2j145w">
        <div className="max-w-3xl mx-auto" data-id="element-601" data-mp="3egm6io4gx3q3">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-602" data-mp="39hrgp2832ewh">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-603" data-mp="34iohvzip54wy">
            <div className="flex-1 p-6 border border-[#7FE0C3]/30 rounded-lg bg-slate-800/30" data-id="element-604" data-mp="2zkd97s4510gb">
              <div className="text-xs text-[#7FE0C3] uppercase tracking-widest mb-2" data-id="element-605" data-mp="2vi9mu8fxkbg9">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-606" data-mp="2qqruu9vvxl7f">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-607" data-mp="2lsgjtvtut4nm">
                The foundation your recruiting runs on.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-608" data-mp="2gv6ojzjs9yrv">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-609" data-mp="2bt90ms0fufsl">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-610" data-mp="27vb8bgbdfdkz">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-611" data-mp="na4uq9d8lgzl">
                Exists when execution capacity is the bottleneck.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-612" data-mp="wbuin57wtxsm">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-613" data-mp="11anukt7jtgqo">
                Leadership
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-614" data-mp="3nyoo89q6jzj">Leadership</h3>
              <p className="text-slate-400 text-sm" data-id="element-615" data-mp="8lqr3w7zxohz">
                Add it when finding leadership becomes the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 10. CTA */}
      <section className="py-32 px-6 md:px-12 text-center" data-id="element-616" data-mp="ic3ctrrjrnpp">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-617" data-mp="3h1tnv6xklsrj">
          Ready to make recruiting predictable?
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-[#7FE0C3] hover:bg-[#5ACCA8] text-[#163A5F] font-bold rounded-lg transition-all transform hover:scale-105" data-id="element-618" data-mp="3m04w5d87vv7n">
          Let's see if Advantage is the right fit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-619" data-mp="39y3y1vee06je" />
        </button>
      </section>
    </div>;
}